import { environmentConfig } from "@src/appV2/environment";

import { COGNITO_IDS } from "./cognitoIds";

interface CognitoConfig {
  userPoolId: string;
  clientId: string;
}

function getCognitoConfig(): CognitoConfig {
  const environmentName = environmentConfig.REACT_APP_ENVIRONMENT_NAME;

  return COGNITO_IDS[environmentName] ?? COGNITO_IDS.development;
}

export const cognitoConfig = getCognitoConfig();
